<template>
    <form v-if="product.id" @submit.prevent="editProduct">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="product.name"
                name="name"
                type="text"
                placeholder="product name"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-4">
            <label class="block mb-1" for="type">Type</label>
            <Dropdown v-model="product.type" :options="['simcard' , 'datasim' , 'rakuten']" placeholder="Select a type" class="w-full" />
        </div>
        <div class="mt-4">
            <Checkbox
                binary
                v-model="product.hide" />
            <label class="ml-2" for="active">Hide product from affiliates</label>
        </div>
        <div>
            <FileUpload :initial="product.image" @upload="getImageId" />
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.update') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits , defineProps, onMounted } from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';
import FileUpload from '@/components/FileUpload.vue'

//prime vue components
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';

const props = defineProps({
    id : Number
})
const emit = defineEmits(['edited']);

const product = ref({
    name : '',
    type : '',
    image_id : null,
    image : {},
    hide : false
})
const errors = ref({});
const loading = ref(false);

const getImageId = (id) => {
    product.value.image_id = id;
}

const editProduct = () => {
    loading.value = true;
    const id = toast.loading('Creating, please wait . . .');
    ApiService.put(`products/${props.id}` , product.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Updated product.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('edited');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error updating produuct.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}

onMounted(() => {
    ApiService.get(`products/${props.id}`).then((res) => {
        product.value = res.data
        product.value.hide = !!product.value.hide
    }).catch(() => {
        toast.error("Error fetching data.");
    })
})
</script>

<style scoped>

</style>